import { FC } from 'react';
import { SUBSCRIPTIONS } from '../constants';
import { formatPrice } from '../lib/formatPrice';

interface SubscriptionTypeProps {
  subscriptionId: string;
  price: number;
  subPrice: number;
}

export const SubscriptionType: FC<SubscriptionTypeProps> = ({
  subscriptionId,
  price,
  subPrice,
}) => {
  const subscription =
    SUBSCRIPTIONS.find((option) => option.id === subscriptionId) ?? SUBSCRIPTIONS[0];

  const description = `${formatPrice(price)} one time registration fee + ${formatPrice(
    subPrice
  )} a month (Starting in 30 days)`;

  return (
    <div className="flex flex-col gap-4">
      <h3 className="[font-size:var(--fs-l1)]! [font-family:var(--font-montserrat)]! text-(--neutral-black-NB1000)! m-0!">
        Subscription details
      </h3>

      <div className="flex flex-1 items-center gap-4 rounded-xl! border border-(--primary-O900) bg-(--primary-O200) p-4 lg:p-8 text-left">
        <span className="flex flex-col gap-1 lg:gap-2">
          <span className="[font-size:var(--fs-p2)]! font-semibold text-(--neutral-black-NB1000)!">
            {subscription.name}
          </span>

          <span className="[font-size:var(--fs-p3)]! text-(--neutral-black-NB700)!">
            {description}
          </span>
        </span>
      </div>
    </div>
  );
};
